import {
  DEVICE_MANAGEMENT_DATA_FAILURE,
  DEVICE_MANAGEMENT_DATA_REQUEST,
  DEVICE_MANAGEMENT_DATA_SUCCESS,
  FIRST_ACTION_TYPE,
  USER_ACCESS_MENU_LINK_DATA_REQUEST,
  USER_ACCESS_MENU_LINK_DATA_SUCCESS,
  USER_ACCESS_MENU_LINK_DATA_FAILURE,
  RELOAD_DETAILS_PAGE,
  DELETE_DETAILS_PAGE_DATA,
  FIRST_TIME_USER_RESET_PWD
  } from "./actionTypes";

export const firstAction = (payload: any) => ({
  type: FIRST_ACTION_TYPE,
  payload,
});







export const enforceUserToChangePassword = (payload: any) => ({
  type: FIRST_TIME_USER_RESET_PWD,
  payload,
});






export const deviceManagementDataRequest = () => ({
  type: DEVICE_MANAGEMENT_DATA_REQUEST,
});

export const deviceManagementDataSuccess = (payload: any) => ({
  type: DEVICE_MANAGEMENT_DATA_SUCCESS,
  payload,
});

export const deviceManagementDataFailure = (payload: any) => ({
  type: DEVICE_MANAGEMENT_DATA_FAILURE,
  payload,
});

export const getMenuLinksInfoForUser = (payload: any) => ({
  type: USER_ACCESS_MENU_LINK_DATA_REQUEST,
  payload,
});

export const getMenuLinksInfoForUserSuccess = (payload: any) => ({
  type: USER_ACCESS_MENU_LINK_DATA_SUCCESS,
  payload,
});

export const getMenuLinksInfoForUserFailure = (payload: any) => ({
  type: USER_ACCESS_MENU_LINK_DATA_FAILURE,
  payload,
});

export const reloadDetailsPage = (payload: any) => ({
  type: RELOAD_DETAILS_PAGE,
  payload,
});


export const deleteDetailsPageData = (payload:any) => ({
  type: DELETE_DETAILS_PAGE_DATA,
  payload
});